import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { PatchAdminV1OrgMediaIdBody } from '@nucleus-commerce/api-client/admin';

import { mediaApi } from '../api/media-api';

import { mediaKeys } from './media-keys';

export interface UseUpdateMediaOptions {
  /** Extra query keys to refresh, e.g. a product gallery that embeds the media row. */
  invalidates?: ReadonlyArray<readonly unknown[]>;
}

export function useUpdateMedia({ invalidates = [] }: UseUpdateMediaOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: PatchAdminV1OrgMediaIdBody }) =>
      mediaApi.update(id, body),
    meta: { successMessage: 'media:toasts.updated', invalidates },
    onSuccess: (media) => {
      queryClient.setQueryData(mediaKeys.detail(media.id), media);
      return queryClient.invalidateQueries({ queryKey: mediaKeys.lists() });
    },
  });
}
